import { Component, inject } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Footer } from '@/app/layout/footer/footer';
import { Navbar } from '@/app/layout/navbar/navbar';
import { Routes } from '@/app/shared/consts/routes';
import { LoginRequest } from '@/app/shared/models/login-request';
import { NotificationService } from '@/app/shared/services/notification.service';
import { AuthService } from '@/app/core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { RecoverKey } from '../recover-key/recover-key';
import {
  TranslateService,
  TranslatePipe
} from "@ngx-translate/core";
import { ErrorDialog, ErrorDialogModel } from '@/app/shared/components/error-dialog/error-dialog';
import { OtpVerification, OtpDialogData } from '../otp-verification/otp-verification';


@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    Navbar,
    Footer, TranslatePipe
  ],
  standalone: true,
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login {
  private translate = inject(TranslateService);
  mostrarPassword = false;
  public routes: typeof Routes = Routes;
  loginForm!: FormGroup;

  constructor(protected router: Router, private formBuilder: FormBuilder, protected ngxLoaderService: NgxUiLoaderService,
    private authService: AuthService, private notificacionService: NotificationService, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      user: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  ngOnDestroy() {

  }

  get f() {
    return this.loginForm.controls;
  }

  login() {

    const loginRequest: LoginRequest = {
      username: this.f['user'].value,
      password: this.f['password'].value
    };

    this.ngxLoaderService.start();
    this.authService.login(loginRequest).subscribe({
      next: (res) => {
        setTimeout(() => {
          this.ngxLoaderService.stop();
          if (this.authService.user && this.authService.user.rol == 'STUDENT')
            this.router.navigate([this.routes.COURSES_STUDENT_ACTIVATED]);
          else
            this.router.navigate([this.routes.LIST_COURSE_APPLICANTS]);

        }, 1000);
      },
      error: (err) => {
        this.ngxLoaderService.stop();

        let msg: string;
        if (typeof err === 'string') {
          msg = err;
        } else if(err.message && typeof err.message === 'string'){
          msg = err.message;
        } else if (err && err.error && typeof err.error.error === 'string') {
          msg = err.error.error;
        } else {
          msg = this.translate.instant('LOGIN.ERROR_LOGIN');
        }

        if (msg === 'CODE_VERIF') {
          this.openOtpVerification();
          return;
        }

        const dialogData = new ErrorDialogModel('Error', msg);
        this.dialog.open(ErrorDialog, { maxWidth: '400px', data: dialogData });   
      },
    });
  }

  openOtpVerification() {
    const dialogData: OtpDialogData = {
      email: this.f['user'].value,
      mode: 'login',
    };

    const dialogRef = this.dialog.open(OtpVerification, {
      width: '420px',
      disableClose: true,
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        this.login();
      }
    });
  }

  onAction() {

    const dialogRef = this.dialog.open(RecoverKey, {
      width: '420px',
      disableClose: true,
      data: { email: this.loginForm.get('user')?.valid ? this.loginForm.get('user')?.value : undefined }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        this.notificacionService.notificationSuccess(
          this.translate.instant('LOGIN.RECOVER_SUCCESS'),
          this.translate.instant('COMMON.SUCCESS')
        );
      }
    });

  }

  actionRegister() {
    this.router.navigate([this.routes.REGISTER]);
  }


}

